import { INITIALIZE_APP_COMPLETED } from '../logic/app/app.actions';
import {
  LOAD_NAVIGATION,
  SET_CURRENT_SECTION_CODE,
  fetchNavigation,
  setCurrentSectionCode,
  setNavigationAllowed,
} from '../logic/layout/layout.actions';
import { getLayoutNavigation } from '../logic/layout/layout.selectors';
import { CLEAR_USER_PROFILE, PAIRING_FETCH_USER_SUCCESS } from '../logic/pairing/pairing.actions';
import { PAIRING_RESET } from '../logic/pairing/unpair.actions';
import { FETCH_PROFILE_INFOS_FAILURE, FETCH_PROFILE_INFOS_SUCCESS } from '../logic/user/user.actions';

const isLayoutFetched = type => /^layout\/.+\/FETCH_LAYOUT_SUCCESS$/.test(type);

const ensureNavigation = ({ getState, dispatch }) => {
  if (!getLayoutNavigation(getState())) {
    dispatch(fetchNavigation());
  }
};

// Decides which navigation is loaded and when; it is only displayed once a non-gate layout sets `navigationAllowed`
export default store => next => action => {
  const { dispatch } = store;

  switch (action.type) {
    case FETCH_PROFILE_INFOS_SUCCESS: {
      const section = action.isKidsProfile ? 'kids' : 'main';
      dispatch(setCurrentSectionCode(section));
      dispatch(fetchNavigation(section));
      break;
    }
    case FETCH_PROFILE_INFOS_FAILURE: {
      dispatch(fetchNavigation('main'));
      break;
    }
    // The profile has to be confirmed by a layout again, otherwise the Sidenav would flash before a profiles gate
    case PAIRING_FETCH_USER_SUCCESS:
    case CLEAR_USER_PROFILE: {
      dispatch(setNavigationAllowed(false));
      break;
    }
    // Logged out, so there is no profile to keep a section for
    case PAIRING_RESET: {
      dispatch(setCurrentSectionCode('main'));
      break;
    }
    default:
      break;
  }

  const result = next(action);

  // NOTE: on app initialization the authentication is resolved and a restored profile has already set its section
  if (
    action.type === INITIALIZE_APP_COMPLETED ||
    action.type === LOAD_NAVIGATION ||
    action.type === SET_CURRENT_SECTION_CODE ||
    isLayoutFetched(action.type)
  ) {
    ensureNavigation(store);
  }

  return result;
};
